import style from "./style.module.scss";
import { useState } from "react";
import arrowImg from "../Arrow.png";
import { ForgetPass, UserAttemptToLogin } from "../../../../../Web/View/Auth/Components/Services";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

const UserLogin = ({ setStep, setisLogin, isWebview }) => {
    let location = useLocation();
    const { mobile } = useSelector(state => state);

    let initialState = {
        mobile: location.state ? location.state.mobile : mobile,
        password: null
    }
    let dispatch = useDispatch();
    const [state, setState] = useState(initialState);
    const UserLoginHandle = (mobile, password) => {
        UserAttemptToLogin(mobile, password).then((result) => {
            if (typeof result === "object") {
                localStorage.removeItem("user")
                dispatch({
                    local_storage: {
                        key: "user",
                        value: result,
                    },
                    type: "SET",
                    payload: { user: result }
                })
                dispatch({
                    local_storage: {
                        key: "user_type",
                        value: result.role
                    },
                    type: "SET",
                    payload: { user_type: result.role }
                })
                if (localStorage.user_type) {
                    if (isWebview) {
                        setisLogin(true)
                    }
                    else {
                        location.reload();
                    }
                }
            }
        })
    }
    const ForgetPasswordHandle = (mobile) => {
        ForgetPass(mobile).then((result) => {
            // if (result.status != 'error') {
            //     console.log(mobile);
            // }
            setStep("step6");
        });
    };

    return (
        <>
            <section>
                <div>
                    <img src={arrowImg} onClick={() => setStep("step2")} className={style.arrowIcon} alt="arrowIcon" />
                    <h3 className={style.titelTextLogin}>ورود / ثبت نام</h3>
                </div>
                <div className="d-flex justify-content-center">
                    <div className="">
                        <p className={style.warnLogin}>لطفا برای ادامه شماره موبایل خود را وارد کنید.</p>
                        <div className={style.parentInputLogin}>
                            <p className="mb-2" style={{ color: "#404040", fontWeight: "500" }}>
                                شماره موبایل
                            </p>
                            <input className={style.inputLogin} type="number" name="number" value={mobile}
                                onChange={(e) => setState({ ...state, mobile: e.target.value })} placeholder="شماره موبایل" id="number" />
                        </div>
                        <div className={style.parentInputLogin}>
                            <p className="mb-2" style={{ color: "#404040", fontWeight: "500" }}>
                                رمز عبور
                            </p>
                            <input className={style.inputLogin} type="password" name="password"
                                onChange={(e) => setState({ ...state, password: e.target.value })} placeholder="رمز عبور" id="password" />
                        </div>
                        <button className={style.btnLogin} onClick={() => UserLoginHandle(state.mobile, state.password)}>ورود</button>
                        <div className="mt-3">
                            <p className={style.endText}> رمز عبور خود را فراموش کرده اید ؟  <span onClick={() => ForgetPasswordHandle(state.mobile)} style={{ color: "#E42A3F", padding: "0 0 10px 0" }}>تغییر رمز عبور</span> </p>
                            <p className={style.endText}> حساب کاربری ندارید ؟ <span onClick={() => setStep("step4")} style={{ color: "#E42A3F", padding: "0 0 10px 0", border: "none" }}> ایجاد حساب کاربری </span></p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default UserLogin;